module.exports = __webpack_public_path__ + "img/custom.6d6b1688.png";